let apiEndpoints;
export function initApiEndpoints(apiBaseUrl) {
    apiEndpoints = {
        warehouses: `${apiBaseUrl}/cw_warehouse`,
        procurementCatalog: `${apiBaseUrl}/cw_procurement_catalog`,
        stockBucket: `${apiBaseUrl}/stockbucket`,
        stockBucketItem: `${apiBaseUrl}/stockbucketItem`,
    };
}
export { apiEndpoints };
